<template>
  <div
    v-if="isPageLoaded && news"
    class="module module-news padding_large"
    v-observe-visibility="visibilityChanged"
    :class="[{ 'show-up': isVisible }, baseAnimation, 'bg-' + data.theme]"
  >
    <ModuleContainer>
      <header class="module-heading-linked">
        <ModuleHeading>{{ data.title }}</ModuleHeading>
        <ArchiveLink type="post">Se alle artikler</ArchiveLink>
      </header>
      <section v-if="news && news.length > 0" class="article-list">
        <SinglePost v-for="(article, i) in news" :key="i" :id="article.id" />
      </section>
      <section v-else class="article-list">
        <SinglePost />
        <SinglePost />
        <SinglePost />
      </section>
    </ModuleContainer>
  </div>
</template>

<script>
import SinglePost from "@/components/blocks/SinglePost";
import ArchiveLink from "@/components/elements/ArchiveLink";

import { mapGetters } from "vuex";

export default {
  name: "news",
  props: ["data"],
  computed: {
    ...mapGetters(["getPosts", "isPageLoaded"]),
    news() {
      let posts = this.getPosts(this.data.news_category);
      //exclude
      if (posts && posts.length > 0) {
        posts = posts.filter(it => {
          return it.id !== this.currentPage.id;
        });
      }

      if (posts && posts.length > 0) {
        let tests = [];
        posts.forEach((post, i) => {
          if (i <= 2) {
            tests.push(post);
          }
        });
        posts = tests;
      }
      return posts;
    }
  },
  components: {
    SinglePost,
    ArchiveLink
  }
};
</script>

<style lang="scss">
@import "./../../assets/scss/mixins.scss";
@import "./../../assets/scss/vars.scss";

.module-news {
  &.bg-gray {
    .post-block-link {
      background: #fff;
    }
  }
  .block-single-post {
    margin-bottom: 0;
    @include mquery(767px) {
      margin-bottom: 15px;
    }
  }
  @include mquery(767px) {
    .block-single-post {
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
}
</style>
